<template>
	<div class="content_main">
		<div class="content_main_top">
			<a-button type="primary" @click="exp"> 导出 </a-button>
		</div>
		<div class="content_main_top">
			<a-range-picker valueFormat="YYYY-MM-DD" style="margin-right: 10px; width: 240px" allowClear :value="dates" @change="onChange"
			 @keyup.enter.native="serch_get_lis" :placeholder="['开始日期', '结束日期']" />
			<a-input class="a_select_self margin_self" v-model="serchInfo.createBy" allowClear placeholder="创建人"
			 @keyup.enter.native="serch_get_lis" />
			<a-input class="a_select_self margin_self" v-model="serchInfo.sendTo" allowClear placeholder="收件邮箱"
			 @keyup.enter.native="serch_get_lis" />
			<a-input class="a_select_self margin_self" v-model="serchInfo.subject" allowClear placeholder="主题"
			 @keyup.enter.native="serch_get_lis" />
			 <a-select show-search allowClear placeholder="邮件发送状态" class="margin_self" style="width: 220px"  v-model="serchInfo.sendStatus" @keyup.enter.native="serch_get_lis">
				<a-select-option :value="item.title" v-for="(item, index) in statusList" :key="index">
					{{ item.title }}
				</a-select-option>
			</a-select>
			
			<a-button type="primary" @click="serch_get_lis"> 查询 </a-button>
		</div>
		<div class="content_main_center_scroll" id="content_main_center_scroll">
			<a-table :data-source="lis" bordered :loading="loading" :pagination="pagination" @change="handleTableChange" :scroll="{y: scroll_y, scrollToFirstRowOnChange: true }">
				<a-table-column key="index" title="序号" data-index="index">
					<template scope="text, record, index">{{ (pagination.current - 1) * pagination.pageSize + index + 1 }}</template>
				</a-table-column>
				<a-table-column key="createBy" title="创建人" ellipsis="true" data-index="createBy" />
				<a-table-column key="createTime" title="创建时间" ellipsis="true" data-index="createTime" />
				<a-table-column key="sendTo" title="收件邮箱" ellipsis="true" data-index="sendTo" />
				<a-table-column key="subject" title="主题" ellipsis="true" data-index="subject" />
				<!-- <a-table-column key="sendStatus" title="发送状态" ellipsis="true" data-index="sendStatus" /> -->
				<a-table-column title="发送状态" width="180px">
					<template scope="text,record">
						<!-- <span>{{record}}</span> -->
							<a-tag :color="record.sendStatus == '发送失败' ? 'red' : 'green' " v-if="record.sendStatus != null">
								{{record.sendStatus}}
							</a-tag>
					</template>
				</a-table-column>
				<a-table-column title="操作">
					<template scope="text,record">
						<a @click="show_details(record)">详情</a>
					</template>
				</a-table-column>
			</a-table>
		</div>
		<a-modal title="邮件详情" :visible="mailvisible" @cancel="mailvisible = false" :confirm-loading="confirmLoading" width="60%"
		 :maskClosable="false">
		 <template slot="footer">
		 	<a-button key="back" @click="mailvisible = false"> 返回 </a-button>
		 </template>
			<a-row style="margin-bottom: 15px"><span class="form_title">邮件基本信息</span></a-row>
			<a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="创建人">
							<div>{{form.createBy}}</div>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="创建时间">
							<div>{{form.createTime}}</div>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="收件邮箱">
							<div>{{form.sendTo}}</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row style="background-color:rgb(247,250,255);height: 100%;border: 2px solid rgb(242,243,247);">
					<a-col :span="24" >
						<a-form-model-item label="邮件主题" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" style="margin-bottom: 0px !important;">
							<div>{{form.subject}}</div>
						</a-form-model-item>
					</a-col>
					<a-col :span="24">
						<a-form-model-item label="邮件内容" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
							<div v-html="form.content"></div>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
	</div>
</template>
<script>
	import {
		getDeptListEnable2
	} from '@/api/system'
	import {
		mail_record
	} from '@/api/administrative'
	import {
		get_biz_car_xlsx
	} from '@/api/assetmenag'
	export default {
		data() {
			return {
				statusList:[
					{
						id: 1,
						title: '已发送'
					},{
						id: 2,
						title: '发送失败'
					}
				],
				changecar: false,
				labelCol: {
					span: 6,
				},
				wrapperCol: {
					span: 18,
				},
				deptTree: [],
				form: {},
				dates: [],
				serchInfo: {
					createBy: '',
					sendTo: '',
					subject: '',
					createTime1: '',
					createTime2: '',
					sendStatus: undefined,
				},
				scroll_y: 150,
				loading: false,
				lis: [],
				pagination: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
				},
				is_details: false,
				mailvisible: false,
			}
		},
		mounted() {
			this.get_list()
		
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() - 120
				}, 1000)
			})
		},
		methods: {
			show_details(row){
				this.mailvisible=true
				this.form=row
			},
			onChange(date, dateString) {
				this.dates = date
				this.serchInfo.createTime1 = date[0]
				this.serchInfo.createTime2 = date[1]
			},
			result() {
				this.serchInfo = {}
			},
			//切换公司
			handlecompany(value) {
				this.deptTree = []
				this.serchInfo.deptId = undefined
				this.$nextTick(() => {
					getDeptListEnable2().then((res) => {
						const data = res.rows
						if (data.length > 0) {
							const min = Math.min(...data.map((m) => m.parentId))
							this.buildtree2(data, this.deptTree, this.serchInfo.companyId)
						}
					})
				})
			},
			exp() {
				// get_biz_car_xlsx({
				// 	pageNum: 1,
				// 	pageSize: 99999,

				// 	excel: 1,
				// })
			},
			buildtree2(list, arr, parentId) {
				list.forEach((item) => {
					if (item.parentId === parentId) {
						var child = {
							key: item.deptId,
							value: item.deptId, // value是给modal的select用的，2者属性不一样
							title: item.deptName,
							scopedSlots: {
								title: 'title',
							},
							children: [],
						}
						this.buildtree2(list, child.children, item.deptId)
						if (child.children.length === 0) {
							delete child.children
						}
						arr.push(child)
					}
				})
			},
			//获取列表
			get_list() {
				mail_record({
					pageIndex: this.pagination.current,
					pageSize: this.pagination.pageSize,
					createBy: this.serchInfo.createBy,
					sendTo: this.serchInfo.sendTo,
					subject: this.serchInfo.subject,
					startDate: this.serchInfo.createTime1,
					endDate: this.serchInfo.createTime2,
					sendStatus: this.serchInfo.sendStatus
				}).then((res) => {
					console.log(res)
					if (res.code == 200) {
						var lis = res.data.list
						this.lis = res.data.list
						const pagination = { ...this.pagination
						}
						pagination.total = res.data.totalCount
						this.pagination = pagination
					} else {
						this.$message.error(res.msg)
					}
					this.loading = false
				})
			},
			//重置
			reset() {
				this.serchInfo = {
					createBy: '',
					sendTo: '',
					subject: '',
					createTime1: '',
					createTime2: '',
				}
			},
			//搜索
			serch_get_lis() {
				this.loading = true
				this.pagination.current = 1
				this.get_list()
			},
			//改变分页
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current
				this.pagination.pageSize = pagination.pageSize
				this.loading = true
				this.get_list()
			}
		},
	}
</script>
<style scoped lang='less'>
	.ant-table td {
		white-space: nowrap;
	}
	.form_title {
		margin-left: 15px;
		margin-bottom: 15px;
		font-size: 17px;
		color: #999;
	}
</style>
